/**
 * Add steps-slide animation to buttons, like the buttons within the grid items below.
 * Target HTML e.g. — refer to projects-grid buttons.
 * <a class="button-animated slide-animation-parent" href="/projects/">
 *     <span>See our projects</span>
 *     <div class="slide-animation">
 *         <div class="slide-animation__part"></div>
 *         <div class="slide-animation__part"></div>
 *         <div class="slide-animation__part"></div>
 *         <div class="slide-animation__part"></div>
 *         <div class="slide-animation__part"></div>
 *     </div>
 * </a>
 */

export default function (buttonsSelector) {
  // Push this to the back of the stack, if there is one.
  window.setTimeout(() => {
    const buttons = [...document.querySelectorAll(buttonsSelector)];
    buttons.forEach((button) => {
      // Add classes to button itself.
      button.classList.add('button-animated', 'slide-animation-parent');
      // Add internal HTML necessary for animation.
      const buttonText = button.innerHTML;
      const animationTemplate = `
        <span>${buttonText}</span>
        <div class="slide-animation">
            <div class="slide-animation__part"></div>
            <div class="slide-animation__part"></div>
            <div class="slide-animation__part"></div>
            <div class="slide-animation__part"></div>
            <div class="slide-animation__part"></div>
        </div>
      `;
      button.innerHTML = animationTemplate;
    });
  }, 1);
}
